// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://tlvngzfoxpjdltbpmzaz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRsdm5nemZveHBqZGx0YnBtemF6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTMyMDAwNTcsImV4cCI6MjA2ODc3NjA1N30.m3ko_uTf9fNUKSsZFkUV6LFyLDEg0sp67G_g3fVMRxA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});